import '../styles/globals.css';
import '../styles/card.css';
import { Toaster } from 'react-hot-toast';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { utils } from '../utils/utils';

function MyApp({ Component, pageProps }) {
	const LOG_LEVEL = {
		DEBUG: 'DEBUG',
		ERROR: 'ERROR',
		WARN: 'WARN',
		INFO: 'INFO',
	};

	const overrideConsoleMethod = (method, logLevel, originalMethod) => {
		console[method] = function (...args) {
			const timestamp = utils.dateTimeToLogString(new Date());
			const logArgs = [timestamp, logLevel, ...args];
			//originalMethod.apply(console, logArgs);
			utils.logToQueue(logArgs.join(' '));
		};
	};

	// Override console methods
	//overrideConsoleMethod('log', LOG_LEVEL.DEBUG, console.log);
	//overrideConsoleMethod('error', LOG_LEVEL.ERROR, console.error);
	//overrideConsoleMethod('warn', LOG_LEVEL.WARN, console.warn);
	//overrideConsoleMethod('info', LOG_LEVEL.INFO, console.info);

	return (
		<div className='min-h-screen bg-lightGray'>
			<Toaster
				position='top-center'
				reverseOrder={false}
				toastOptions={{
					success: {
						iconTheme: {
							primary: '#ffffff',
							secondary: '#387a99',
						},
					},
				}}
			/>
			<DndProvider backend={HTML5Backend}>
				<Component {...pageProps} />
			</DndProvider>
		</div>
	);
}

export default MyApp;
